import { BaseService } from "@flint/framework";

export default class EPubUpload extends BaseService {
  constructor() {
    super("UPLOAD_EPUB", "EPubUploadStore", true);
  }

  handleEvent(eventName, event) {
    let formData = new FormData();
    formData.append("file", event.term);
    return this.getClient("vetService").post("/admin-api/epubs/", formData);
  }
}
